var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPngIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PNG_File",
    "data-name": "PNG File",
    transform: "translate(10756 3822)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 42,
    height: 42,
    transform: "translate(-10756 -3822)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "png",
    transform: "translate(-10754.554 -3818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M25.009,0H7.388C6.9,0,6.5.4,6.5,1.169V33.393A.914.914,0,0,0,7.388,34H31.719a.914.914,0,0,0,.888-.607V7.879c0-.423-.056-.559-.156-.659L25.386.156A.537.537,0,0,0,25.009,0Z",
    transform: "translate(0 0)",
    fill: "#e9e9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M31.719,49.321H7.388a.888.888,0,0,1-.888-.888V39H32.607v9.433A.888.888,0,0,1,31.719,49.321Z",
    transform: "translate(0 -15.321)",
    fill: "#659c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M37.5.151V7.345h7.194Z",
    transform: "translate(-12.179 -0.059)",
    fill: "#d9d7ca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(12.112 25.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M16.74,49.042h-1V42.924H17.5a2.47,2.47,0,0,1,.772.124,2.1,2.1,0,0,1,.685.373,1.95,1.95,0,0,1,.49.6,1.667,1.667,0,0,1,.187.793,2.169,2.169,0,0,1-.158.843,1.761,1.761,0,0,1-.44.635,1.983,1.983,0,0,1-.681.4,2.619,2.619,0,0,1-.88.141H16.74v2.208Zm0-5.362V46.1h.913a1.085,1.085,0,0,0,.361-.063.91.91,0,0,0,.328-.2.994.994,0,0,0,.24-.394,1.867,1.867,0,0,0,.091-.627,1.7,1.7,0,0,0-.041-.344.994.994,0,0,0-.17-.373,1.006,1.006,0,0,0-.361-.3,1.342,1.342,0,0,0-.614-.12H16.74Z",
    transform: "translate(-15.744 -42.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    d: "M28.453,42.924v6.118H27.441l-2.4-4.217v4.217H24.029V42.924h1.013l2.4,4.217V42.924Z",
    transform: "translate(-18.999 -42.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    d: "M38.206,45.823v2.365a1.787,1.787,0,0,1-.427.394,2.612,2.612,0,0,1-1.038.395,3.7,3.7,0,0,1-.552.041,2.51,2.51,0,0,1-1.008-.2,2.259,2.259,0,0,1-.805-.59,2.781,2.781,0,0,1-.54-.979,4.836,4.836,0,0,1,0-2.718,2.767,2.767,0,0,1,.54-.975,2.3,2.3,0,0,1,.809-.594,2.47,2.47,0,0,1,1-.2,2.57,2.57,0,0,1,.93.166,2.268,2.268,0,0,1,.772.5l-.689.614a1.185,1.185,0,0,0-.457-.348,1.367,1.367,0,0,0-.531-.108,1.5,1.5,0,0,0-.585.116,1.254,1.254,0,0,0-.5.394,2.03,2.03,0,0,0-.344.718,4.236,4.236,0,0,0-.133,1.079,4.5,4.5,0,0,0,.129,1.079,2.214,2.214,0,0,0,.332.747,1.415,1.415,0,0,0,.481.432,1.209,1.209,0,0,0,.569.141c.061,0,.142,0,.245-.013a2.98,2.98,0,0,0,.307-.041,2,2,0,0,0,.294-.079.422.422,0,0,0,.208-.141V46.5H36.181v-.681h2.025Z",
    transform: "translate(-22.775 -42.76)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 2.774,
    cy: 2.774,
    r: 2.774,
    transform: "translate(11.273 5.988)",
    fill: "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M6.5,30.946H32.607V24.268L26.536,18.5l-6.375,6.982-3.329-3.329Z",
    transform: "translate(0 -7.268)",
    fill: "#88c057"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngIcon);
export default __webpack_public_path__ + "static/media/pngIcon.c6844b4f1b8411dcfa53af709cb5ed7a.svg";
export { ForwardRef as ReactComponent };